import React, { useEffect, useState } from "react";
 
const SourceList = ({ sources,isArabic }) => {
  const [showAll, setShowAll] = useState(false);
 
  useEffect(() => {
    console.log("SourceList component mounted");
    console.log("Sources:", sources);
  }, [sources]);
 
  console.log("Received sources:", sources);
 
  let parsedSources;
  try {
    parsedSources = typeof sources === 'string' ? JSON.parse(sources) : sources;
  } catch (error) {
    console.error("Failed to parse sources:", error);
    return null;
  }
 
  if (!Array.isArray(parsedSources) || parsedSources.length === 0) {
    console.log("Parsed sources is not an array or is empty");
    return null;
  }
 
  const visibleSources = showAll ? parsedSources : parsedSources.slice(0, 3);
  return (
    <div className={`sources-list flex flex-wrap gap-4 mt-4 `}>
      {visibleSources.map((source, index) => (
        <div
          key={index}
          className="flex items-center border border-border rounded-lg p-2 shadow-sm bg-white"
        >

<img
  src={`https://www.google.com/s2/favicons?domain=${source.value}`}
  alt={`${source.title || source.value} favicon`}
  className={`w-5 h-5 ${isArabic?"ml-2":"mr-2"}`}
/>
<a
  href={source.value}
  rel="noopener noreferrer"
  target="_blank"
  style={{ color: "#007560" }}
  className="hover:underline font-semibold"
  title={source.title || source.value} // Tooltip with full source title
>
  { source.title || source.value}
</a>
        </div>
      ))}
 
      {parsedSources.length > 3 && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="flex items-center border border-border rounded-lg p-2 shadow-sm bg-white"
          style={{
            width: "fit-content",
            color: "#007560",
          }}
        >
          <h1 style={{ color: "#007560" }}>
            {showAll ? "<" : ">"}
          </h1>
        </button>
      )}
    </div>
  );
};
 
export default SourceList;